import { State } from "@/store/modules/superSpace/index";

const setSuperSpace = (state: State, payload): void => {
  state.superSpace = payload;
};
const setSuperSpaces = (state: State, payload): void => {
  state.superSpaces = payload;
};

const addSuperSpaces = (state: State, payload): void => {
  const combine = [...state.superSpaces, ...payload];
  const filter = combine.filter(
    (a, index, arr) => arr.findIndex((b) => b.id === a.id) === index
  );
  state.superSpaces = filter;
};

const updateSuperSpaceFavorite = (state: State, payload): void => {
  const index = state.superSpaces.findIndex((a) => a.id === payload.id);
  state.superSpaces.splice(index, 1, payload);
};
const setSuperSpacesAvailablePage = (state: State, payload: number): void => {
  state.superSpacesAvailablePage = payload;
};

const setLastPageSuperSpaces = (state: State, payload: number): void => {
  state.lastPageSuperSpaces = payload;
};

const changeMultiWebinarInStore = (state: State, payload): void => {
  state.superSpace.isMultiWebinarActivated = payload;
};

export default {
  setSuperSpace,
  setSuperSpaces,
  setSuperSpacesAvailablePage,
  setLastPageSuperSpaces,
  addSuperSpaces,
  updateSuperSpaceFavorite,
  changeMultiWebinarInStore,
};
